import { UrlApi } from "../../services/apirest";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import DoneAllIcon from "@mui/icons-material/DoneAll";

export async function preparar({
  cliente,
  direccion,
  suc,
  itemsForm,
  leyenda,
  ocs,
  remitosTexto,
  mostrarPrefactura,
  setRegPrefactura,
  setLoading
}) {
  try {
    if(itemsForm.length > 0 ){
      const idsRemitos = [...new Set(itemsForm.flatMap(item => item.ids_remitos_incluidos))];
      const idsPedidos = [...new Set(itemsForm.flatMap(item => item.ids_pedidos))];
      let clienteCorrespondiente = cliente?.entrega_con_remito === 1 ? cliente?.facturar_a : cliente.id;

      const enviar = {
        leyendaManual: leyenda || null,
        ocs: ocs || null,
        textoRemitos: remitosTexto || null,
        // idCliente: cliente?.id,
        idCliente: clienteCorrespondiente,
        idNegocioCliente:cliente?.id_tipocliente,
        idDireccion:direccion,
        tipoCompGen:1, 
        sucEmisora:suc.id,
        empEmisora:cliente?.id_empresa,
        netoFront:null,
        aConsFinal:0,
        idPedidoRemito:null,
        idsRemitos:idsRemitos,
        idsPedidos:idsPedidos,
        usuarioEmite:localStorage.getItem("user"),
          renglones:itemsForm.map(item=>({
            detalle:item.producto,
            cantidad:item.cantidad_total,
            perc_iva: item.porc_perc_iva,
            descUnidadMedida:item?.nombre_um?.toUpperCase(),
            idProducto:item?.id_producto,
            precio_x_kg:"",
            precio_x_lt:"",
            prun_coniva: Number(item?.precioConIva),
            precioUnitario: Number(item?.precioSinIva),
            totalItem:Number(item?.totalItem),
        })),
        origen:4
      }

      const res = await fetch(
        `${UrlApi}/prefacturas/arma_prefactura`
        , {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(enviar),
        }
      )

      if (res.ok) {
        const data = await res.json();
        if (!!data) {
          const respuesta = await fetch(UrlApi + "/prefacturas/" + data.id)
          const prefac = await respuesta.json();
          setRegPrefactura(prefac)
          if (!!prefac.data) {
            setLoading(false)
            mostrarPrefactura(true)
          }
        }

      } else {
        const error = await res.json();
        alert(`${error.error}. ${error.detalle || ''} ` || "Error")
        if (setLoading) {
          setLoading(false)
        }
      }
    }
  } catch (error) {
    console.log(error)
  } 

}

export async function facturar(pedido, setRespuesta) {
  try {
    const response = await fetch(
      UrlApi + "/pedidos/facturar/facturacion_especial",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(pedido),
      }
    );
    const respuesta = await response.json();
    setRespuesta({
      open: true,
      title: respuesta.error ? "Error al facturar." : "Facturación exitosa.",
      message: respuesta.message || JSON.parse(respuesta.error).message,
      importe_total: respuesta.importe_total || null,
      facturaId: respuesta.facturaId,
      color: respuesta.error ? "#ff0201" : "#48c9b0",
      icon: respuesta.error ? (
        <ErrorOutlineIcon sx={{ fontSize: 40 }} />
      ) : (
        <DoneAllIcon sx={{ fontSize: 40 }} />
      ),
    });
  } catch (error) {
    setRespuesta({
      open: true,
      title: "Error",
      message: "Error interno del servidor.",
      color: "#ff0201",
      icon: <ErrorOutlineIcon sx={{ fontSize: 40 }} />,
    });
  }
}
